import { render, staticRenderFns } from "./TreeSelectDropdownSelectedItem.vue?vue&type=template&id=50f98614"
import script from "./TreeSelectDropdownSelectedItem.vue?vue&type=script&lang=js"
export * from "./TreeSelectDropdownSelectedItem.vue?vue&type=script&lang=js"
import style0 from "./TreeSelectDropdownSelectedItem.vue?vue&type=style&index=0&id=50f98614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports